import React from "react";
import {useTranslation} from "react-i18next";
import {SecondaryButton} from "./SecondaryButton";
import {SxProps} from "@mui/system";
import {Theme} from "@mui/material/styles";

export function CancelButton(props: {
  onClick: () => void,
  title?: string,
  sx?: SxProps<Theme>,
}) {
  const {t} = useTranslation();
  return (
    <SecondaryButton onClick={props.onClick} title={props.title || t('buttons.cancel')} sx={props.sx}/>
  )
}
